import ParcelexApi from '@/services/parcelex';

export default {
  getInstallmentData({ installmentId, transactionId }) {
    return ParcelexApi.get(`/public/transaction/${transactionId}/installment/${installmentId}`);
  },
};
